import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check your .env file.'
  )
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: localStorage
  }
})

// PostgREST caps every response at the project's max_rows (1000 here). The
// dashboards need whole tables to compute stats client-side, and an un-paged
// select silently truncates — the push dashboard read the 1000 newest entries
// against the 1000 *oldest* events and showed Delivered 0 / Pending 1000.
// Page with .range() until a short page comes back. Pass `order` so pages are
// stable; an unordered range walk can skip or repeat rows between pages.
export const PAGE_SIZE = 1000

// `eq` is an optional { column: value } map applied as equality filters.
export async function fetchAllRows(table, select, order, eq) {
  const rows = []
  for (let from = 0; ; from += PAGE_SIZE) {
    let query = supabase.from(table).select(select).range(from, from + PAGE_SIZE - 1)
    if (order) query = query.order(order.column, { ascending: order.ascending ?? true })
    if (eq) {
      for (const [column, value] of Object.entries(eq)) {
        if (value !== undefined && value !== null) query = query.eq(column, value)
      }
    }
    const { data, error } = await query
    if (error) throw error
    rows.push(...(data || []))
    if (!data || data.length < PAGE_SIZE) break
  }
  return rows
}
